import { GetServerSideProps } from 'next';
import MainDocument from 'presentations/views/components/MainDocument';
import BlogPage from 'presentations/views/components/pages/BlogPage';
import { apiPath, engineeringPath, webPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { BlogItem } from 'presentations/api/schema/contents';
import { formatHeadDescription } from 'presentations/views/helpers/formatter';
import AboutHeader from 'presentations/views/components/organisms/AboutHeader';
import BlogListSidebar from 'presentations/views/components/organisms/BlogListSidebar';

interface ServerProps {
  item: BlogItem;
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
}: any) => {
  if (!params) return { notFound: true };
  const slug = String(params.slug);

  const result = await get(
    apiPath(`/v1/contents/blogs/${slug}`, {
      locale,
    }),
  );
  if (!result.isSuccess) {
    return { notFound: true };
  }
  if (!result.data) {
    return { notFound: true };
  }

  const item: BlogItem = result.data;
  const props: ServerProps = {
    item,
    linkCanonical: webPath(engineeringPath(slug), locale),
  };
  return {
    props,
    // revalidate: 60 * 120
  };
};

export default function Page(props: ServerProps) {
  const description = formatHeadDescription(props.item.body);
  return (
    <MainDocument
      title={props.item.title}
      image={props.item.ogImageUrl}
      description={description}
      linkCanonical={props.linkCanonical}
      url={props.linkCanonical}
      isCorpSite
    >
      <BlogPage
        blog={props.item}
        populars={[]}
        header={<AboutHeader />}
        siderbar={<BlogListSidebar />}
      />
    </MainDocument>
  );
}
